if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
    
    // Remove empty <p> tags created by tinymce
    // const paragraph = document.querySelectorAll('p') || [];
    let paragraph = Array.prototype.slice.call(document.querySelectorAll('p')); 
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    let formTypeOfEven = document.querySelector('#weddingForm .form-type-of-even');
    let sendtoInput = document.querySelector('#weddingForm #sendto-input');
    let formTypeOfEvenBottom = document.querySelector('#weddingFormBottom .form-type-of-even');
    let sendtoInputBottom = document.querySelector('#weddingFormBottom #sendto-input');
    
    function addEmail(value, input) {
        if(value === 'proposal-services') {
            input.value = "CHernandez@thepalmshotel.com";
        }else {
            input.value = "";
        }
    }

    if(formTypeOfEven != undefined ){
        formTypeOfEven.addEventListener('change', function() {
            addEmail(this.value, sendtoInput);
        });
    }
    if(formTypeOfEvenBottom != undefined ){
        formTypeOfEvenBottom.addEventListener('change', function() {
            addEmail(this.value, sendtoInputBottom);
        });
    }

    $('.sym-slides').slick({
        accessibility: false
    });
    $('.reviews').slick({
        fade:true,
        accessibility: false,
        responsive: [
            {
              breakpoint: 600,
              settings: {
                arrows:false,
                dots: true,
                adaptiveHeight:true
              }
            }
        ]
    });

    $('.services-text').slick('slickSetOption', 'customPaging', function(s,i){
        let label = $(s.$slides[i]).data('label') ? $(s.$slides[i]).data('label') : i+1;
        return `<span>${label}</span>`;
    }, true)

    $('.fancybox-module').fancybox({
        maxWidth: 650,
        wrapCSS: 'fancybox-popup__wrapper'
    });

    // VIDEO MODULE
    var videoList = document.getElementsByTagName("video");
    function stopVideo(){
        for (var i = 0; i < videoList.length; i++) {
            videoList[i].pause();
            videoList[i].currentTime = 0;
        }
    }

    $('.video-module__trigger').click(function(){
        var videoId = $(this).data('tag');

        $('#video-module__popup-' + videoId).fadeIn();
        document.getElementById('myVideoPlayer-' + videoId).play();
    });

    $('.video-module__close').click(function(){
        $('.video-module__popup').fadeOut();
        stopVideo();
    });

    //vanilla JS fancybox
	if(document.getElementsByClassName('lightbox').length > 0){
		let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
		let allLightboxesLength = allLightboxes.length;

		for(let j = 0; j < allLightboxesLength; j++ ){
			allLightboxes[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				document.getElementById(currentTarget).classList.add('open')
			});
		}

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		for(let j = 0; j < allLightclosesLength; j++ ){
			allLightcloses[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.parentElement.parentElement.id;
				document.getElementById(currentTarget).classList.remove('open')
			});
		}
	}

})();